module.exports = __webpack_public_path__ + "static/media/bio-wt.cf85d1f0.jpg";